import { Select } from "antd";
import numeral from "numeral";
import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import { useDispatch, useSelector } from "react-redux";

const Option = Select.Option;

const ExtraRegimeField = ({ regimeVal, isMonoRegime, article, onArticleChange, isAccountRow, regimeFind, setRegimeFind }) => { 
  const dispatch = useDispatch();
  const regimes = useSelector(state => state.precog.vat.regimes);
  const compensationRates = useSelector(state => state.precog.vat.compensation.list);
  const flatRates = useSelector(state => state.precog.vat.flatRates.list);

  const [compensationList, setCompensationList] = useState([]);
  const [flatRatesList, setFlatRatesList] = useState([]);
  const [extraFieldList, setExtraFieldList] = useState([]);
  const [compensationVal, setCompensationVal] = useState(undefined);
  const [flatRateVal, setFlatRateVal] = useState(undefined);
  const [extraFieldVal, setExtraFieldVal] = useState(undefined);

  useEffect(() => {
    if (!regimeVal) return;
    const currentRegime = regimes.list.find(x => x.id === regimeVal);
    setRegimeFind(currentRegime);
    if (!article?.regimeExtraField) return;
    if (currentRegime?.field && currentRegime?.field?.includes("compensazione") && currentRegime?.values[0] === "0-100") {
      setCompensationVal(article.regimeExtraField);
    } else if (currentRegime?.field && currentRegime?.field?.includes("forfettizzazione") && currentRegime?.values[0] === "0-100") {
      setFlatRateVal(article.regimeExtraField);
    } else {
      setExtraFieldVal(article.regimeExtraField);

    }
  }, [regimeVal, article?.regimeExtraField]);

  useEffect(() => {
    if (!regimeFind?.values) return;
    const extraFieldOptions = [];
    regimeFind?.values.forEach((el, index) => {
      extraFieldOptions.push(<Option
        key={`extra_field_option_${index}`}
        value={el}>{el}%
      </Option>);
    });
    setExtraFieldList(extraFieldOptions);
  }, [regimeFind]);

  useEffect(() => {
    if (!compensationRates) return;
    const optionCompensations = [];
    compensationRates.forEach((el, index) => {
      optionCompensations.push(<Option
        key={`compensation_option_${index}`}
        value={el.id}>
        {numeral(el.value).format("0,0.00")}%
      </Option>);
    });
    setCompensationList(optionCompensations);
  }, [compensationRates]);

  useEffect(() => {
    if (!flatRates) return;
    const optionFlatRates = [];
    flatRates.forEach((el, index) => {
      optionFlatRates.push(<Option
        key={`compensation_option_${index}`}
        value={el.id}>
        {numeral(el.value).format("0,0.00")}%
      </Option>);
    });
    setFlatRatesList(optionFlatRates);
  }, [flatRates]);

  return (
    <>
      {(regimeFind?.field && regimeFind?.values[0] === "0-100") ? regimeFind?.field?.includes("compensazione") ? 
        <Select
          data-testid={"ExtraRegimeField"}
          showSearch
          allowClear
          value={compensationVal}
          style={{
            width: !isAccountRow ? 150 : isMonoRegime !== "MULTI" ? "60%" : "40%", textAlign: "center"
          }}
          dropdownClassName={isAccountRow ? "articles-accordion-select-container" : "split-article-input-accordion"}
          placeholder={regimeFind?.field}
          optionFilterProp="children"
          className={isAccountRow ? "articles-accordion-select" : "split-article-input"}
          getPopupContainer={trigger => isAccountRow ? document.querySelector(".ant-table-tbody") : trigger.parentNode}
          filterOption={(input, option) => option.children.toString().indexOf(input) >= 0}
          onClear={() => {
            setCompensationVal(undefined);
            onArticleChange("fieldsToDelete", ["regimeExtraField"]);
          }}
          onSelect={ (val) => {
            setCompensationVal(val);
            onArticleChange("regimeExtraField", val);
          }}
        >
          {compensationList}
        </Select>
        : regimeFind?.field?.includes("forfettizzazione") ? 
          <Select
            data-testid={"ExtraRegimeField"}
            showSearch
            allowClear
            value={flatRateVal}
            style={{
              width: !isAccountRow ? 150 : isMonoRegime !== "MULTI" ? "60%" : "40%", textAlign: "center"
            }}
            dropdownClassName={isAccountRow ? "articles-accordion-select-container" : "split-article-input-accordion"}
            placeholder={regimeFind?.field}
            optionFilterProp="children"
            className={isAccountRow ? "articles-accordion-select" : "split-article-input"}
            getPopupContainer={trigger => isAccountRow ? document.querySelector(".ant-table-tbody") : trigger.parentNode}
            filterOption={(input, option) => option.children.toString().indexOf(input) >= 0}
            onClear={() => {
              setFlatRateVal(undefined);
              onArticleChange("fieldsToDelete", ["regimeExtraField"]);
            }}
            onSelect={ (val) => {
              setFlatRateVal(val);
              onArticleChange("regimeExtraField", val);
            }}
          >
            {flatRatesList}
          </Select>
          : <NumberFormat
            displayType={"number"}
            data-testid={"ExtraRegimeField"}
            allowEmptyFormatting={false}
            allowLeadingZeros={false}
            thousandSeparator={"."}
            decimalSeparator={","}              
            className={isAccountRow ? "articles-accordion-input" : "split-article-input"}
            placeholder={regimeFind.field}
            style={{
              width: !isAccountRow ? 150 : isMonoRegime !== "MULTI" ? "60%" : "40%",
              padding: 0
            }}
            suffix={"%"}
            isNumericString={extraFieldVal ? true : false}
            value={extraFieldVal ?  numeral(parseFloat(extraFieldVal)).format("0,0") : null}                   
            onValueChange={(el) => { 
              const percentageToSet = el.floatValue > 100 ? 100 : (el.floatValue < 0 ? undefined : el.floatValue);              
              setExtraFieldVal(percentageToSet);             
            }                
            }  
            onBlur={() => {
              if (!extraFieldVal) {
                dispatch({type: "STOP_ACCOUNTS_REFRESH"});
                onArticleChange("fieldsToDelete", ["regimeExtraField"]);
              } else {
                dispatch({type: "STOP_ACCOUNTS_REFRESH"});
                onArticleChange("regimeExtraField", extraFieldVal);
              }
            }}                                  
          />
        : null}
      {(regimeFind?.field && regimeFind?.values?.length === 3) && (
        <Select
          data-testid={"ExtraRegimeField"}
          showSearch
          allowClear
          value={extraFieldVal}
          style={{
            width: !isAccountRow ? 150 : isMonoRegime !== "MULTI" ? "60%" : "40%", textAlign: "center"
          }}
          dropdownClassName={isAccountRow ? "articles-accordion-select-container" : "split-article-input-accordion"}
          placeholder={regimeFind.field}
          optionFilterProp="children"
          className={isAccountRow ? "articles-accordion-select" : "split-article-input"}
          getPopupContainer={trigger => isAccountRow ? document.querySelector(".ant-table-tbody") : trigger.parentNode}
          filterOption={(input, option) => 
            option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          onClear={() => {
            setExtraFieldVal(undefined);
            onArticleChange("fieldsToDelete", ["regimeExtraField"]);
          }}
          onSelect={ (val) => {
            setExtraFieldVal(val);
            onArticleChange("regimeExtraField", val);
          }}
        >
          {extraFieldList}
        </Select>
      )}
    </>
  );
};

export default ExtraRegimeField;
